export const pageSize = 5;
export const ITEM_PER_PAGE = 20;
export const ITEM_PER_PAGE_RESPONDER = 10;

export const bodyGetBasedCost = {
  countryCode: 'US',
  service: 'LANDLINE_CHECK',
  vendor: 'nexmo',
};

export const filterDidsInitial = {
  pageIndex: 0,
  pageSize: 50,
  phone: '',
  type: '',
  username: '',
  groupName: '',

  dateRangesCreatedDate: {
    from: undefined,
    to: undefined,
  },
  dateRangesNextChargeDate: {
    from: undefined,
    to: undefined,
  },

  duplicated: null,
};

export const filterDidsHistoryInitial = {
  pageIndex: 0,
  pageSize: 50,
  phone: '',
  type: '',
};

// Helper function to set time on date (inline to avoid circular dependency)
const setTimeOnDate = (date, { hours = 0, minutes = 0, seconds = 0 } = {}) => {
  const newDate = new Date(date);
  newDate.setHours(hours);
  newDate.setMinutes(minutes);
  newDate.setSeconds(seconds);
  return newDate;
};

export const filterDevicePool = {
  pageIndex: 0,
  pageSize: 100,
  active: '',
  carrierName: '',
  codes: [''],
  deviceName: '',
  email: '',
  groupName: '',
  note: '',
  osVersion: '',
  phoneNumber: '',
  rackName: '',
  sortBy: '',
  sortDirection: 'DESC',
  versionCode: '',
  zipCode: '',
  stateRanges: {
    from: setTimeOnDate(new Date(), { hours: 0, minutes: 0, seconds: 0 }),
    to: setTimeOnDate(new Date(), { hours: 23, minutes: 59, seconds: 59 }),
  },

  stable: null,
};

export const filterDomainInitial = {
  limit: 20,
  offset: 0,
  name: '',
  page: 0,
};

export const filterNotificationInitial = {
  offset: 0,
  limit: 5,
  status: true,
  page: 1,
};

export const filterContactInitial = {
  name: '',
  size: ITEM_PER_PAGE,
  page: 0,
};

export const filterTicketInitial = {
  title: '',
  limit: 20,
  offset: 0,
  status: -1,
};

export const filterCampaignDomainInitial = {
  limit: 5,
  offset: 0,
};

export const filterResponderDomainInitial = {
  page: 0,
  size: 5,
};

export const filterLoadDomainDetailInitial = {
  sortFields: 'deliveryRate',
  sortDirections: 'DESC',
  pageSize: 50,
  pageIndex: 0,
  pageCount: 1,
  searchValues: '',
};

export const filterContactDetailInitial = {
  pageSize: 50,
  page: 1,
  searchValue: '',
  sortFields: 'creation_date',
  sortDirections: 'desc',
};
